<template>
  <div>
    <div :id="overlayId" :class="['modal', overlayClass]">
      <div :class="[modalContentDefaultClass, modalContentClass]">
        <button v-if="closeButtonVisible" class="btn modal-close">
          <i class="icon-close"></i>
        </button>

        <div class="modal__header"></div>

        <slot name="default"></slot>
      </div>
    </div>

    <div class="overlay"></div>
  </div>
</template>

<script>
export default {
  name: 'BaseModal',
  props: {
    closeButtonVisible: {
      type: Boolean,
      default: true
    },
    overlayId: {
      type: String,
      default: ''
    },
    overlayClass: {
      type: [String, Array, Object],
      default: ''
    },
    modalContentDefaultClass: {
      type: String,
      default: 'modal__content'
    },
    modalContentClass: {
      type: [String, Array, Object],
      default: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/modal/BaseModal.vue